// extracted by mini-css-extract-plugin
export default {"head":"style_head__kKvZS","title":"style_title__9ox7Y","time":"style_time__M5fRn","content":"style_content__H1LOg","tabs":"style_tabs__uKpYr"};